<template>
  <div class="modal warning fade" :class="{ 'is-open': show }">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-body">
          <div class="d-flex">
            <div class="warning__img">
              <img
                :src="`${BaseUrl}assets/common/warning.png`"
                :srcset="`${BaseUrl}assets/common/warning@2x.png`"
              />
            </div>
            <content class="mfInfo__content">
              <div
                class="mfInfo__content__title"
                v-html="content"
                v-if="content != ''"
              ></div>
              <div class="mfInfo__content__detail" v-html="detail"></div>
              <div class="mfInfo__content__warning" v-html="warning"></div>
            </content>
          </div>

          <div class="action text-right">
            <a
              @click="cancel()"
              class="btn btn-default px_5 mr_10"
              v-if="needCancelBtn"
              >{{ cancelText }}</a
            >
            <a @click="ok()" ref="okBtn" class="btn btn-primary px_5">{{
              okText
            }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";

export default {
  name: "mfInfo",
  computed: {
    ...mapGetters(["BaseUrl"]),
  },
  data() {
    return {
      show: false,
      content: "",
      event: null,
      cancelEvent: null,
      needCancelBtn: false,
      okText: "確定",
      detail: "",
      warning: "",
      cancelText: "取消",
      keyEvent: (event) => {
        if (this.show && event.key === "Enter") {
          this.$refs.okBtn.click();
        }
      },
    };
  },
  mounted() {
    Vue.prototype.$mfNotice = (
      content,
      event = null,
      needCancelBtn = false,
      cancelEvent = null,
      okText = "確定",
      detail = "",
      warning = "",
      cancelText = "取消"
    ) => {
      this.show = true;
      this.content = content;
      this.event = event;
      this.needCancelBtn = needCancelBtn;
      this.cancelEvent = cancelEvent;
      this.okText = okText;
      this.detail = detail;
      this.warning = warning;
      this.cancelText = cancelText;
    };
    window.addEventListener("keydown", this.keyEvent);
  },
  destroyed() {
    window.removeEventListener("keydown", this.keyEvent);
  },
  methods: {
    cancel() {
      if (this.cancelEvent) this.cancelEvent();
      this.show = false;
      this.content = "";
      this.detail = "";
    },
    ok() {
      if (this.event) this.event();
      setTimeout(() => {
        this.show = false;
        this.content = "";
        this.detail = "";
      }, 50);
    },
  },
};
</script>
<style lang="scss" scoped>
.mfInfo__content {
  &__title {
    font-size: 20px;
    padding: 8px 20px;
    font-weight: 700;
  }
  &__detail {
    padding: 8px 20px;
  }
  &__warning {
    padding: 8px 20px;
    font-size: 20px;
    font-weight: 700;
    color: #de4054;
  }
}
.warning__img {
  width: 52px;
  flex-shrink: 0;
  flex-grow: 0;
  img {
    width: 100%;
  }
}
</style>
